import React from 'react';
import PropTypes from 'prop-types';

import { LeadPropTypes } from 'components/project/prop_types';
import LeadsFunnelRow from './leads_funnel_row';

const NO_STATUS = 'No Status';

export default class LeadsFunnel extends React.Component {
  static propTypes = {
    handleFilterChange: PropTypes.func,
    leads: PropTypes.arrayOf(LeadPropTypes).isRequired,
    leadStatuses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })),
    limit: PropTypes.number,
    moveToTab: PropTypes.func
  };

  renderStatus = (status) => {
    const count = this.props.leads.filter(lead => lead.status === status.id).length;

    return (
      <LeadsFunnelRow
        count={count}
        handleFilterChange={this.props.handleFilterChange}
        key={status.id}
        moveToTab={this.props.moveToTab}
        status={status}
        totalCount={this.props.leads.length}
      />
    );
  }

  statuses() {
    const statuses = this.props.leadStatuses.filter(status => NO_STATUS !== status.label);

    return this.props.limit ? statuses.slice(0, this.props.limit - 1) : statuses;
  }

  render() {
    const { handleFilterChange, leads, leadStatuses, limit, moveToTab } = this.props;

    return (
      <React.Fragment>
        <table className="leads-funnel w-100">
          <tbody>
            <LeadsFunnelRow
              count={leads.length}
              handleFilterChange={handleFilterChange}
              label="All Leads"
              moveToTab={moveToTab}
              totalCount={leads.length}
            />
            {this.statuses().map(this.renderStatus)}
          </tbody>
        </table>
        {limit && leadStatuses.length > limit - 1 && <p className="mt-1 text-muted">More statuses in expanded view</p>}
      </React.Fragment>
    );
  }
}
